<template>
  <div class="card shadow">
    <div class="card-header bg-transparent">
      <div>
        <h3 class="mb-0 title">
          {{ $tc('message.validation',1) }}
        </h3>
      </div>
    </div>
    <b-container class="p-0">
      <b-row v-if="!mobileView" class="table table-responsive">
           <b-table :items="notif_validation_prix" :fields="fields" :tbody-tr-class="rowClass" @row-selected="rowSelected">
              <template #cell(action)="data">
                <div class="col-sm-6" v-if="data.item.consultation != null">
                  <div v-if="data.item.etat_validation_souscripteur == null">
                    <b-link :to="{ name: 'examen-validation-prix', params: { consultation: data.item.consultation.slug },query:{activeTab:'examen'} }">
                        <button class="bg-danger pl--2 text-white border-0 border-danger rounded">
                          <i class="fas fa-exclamation-circle p-2"></i> Valider les examens
                        </button>
                    </b-link>
                  </div>
                  <div v-else>
                    <b-link :to="{ name: 'examen-validation-prix', params: { consultation: data.item.consultation.slug },query:{activeTab:'view'} }">
                      <button class="bg-primary text-white pl--2 border-0 border-primary rounded">
                      <i class="fa fa-eye p-2" aria-hidden="true"></i>  Voir les examens 
                    </button>
                    </b-link>
                    <!-- <b-link  class="btn btn-primary text-white"> Voir </b-link> -->
                  </div>
                </div>
              </template>
           </b-table>
      </b-row>

        <b-row v-else>
             <div v-for="(validation,index) in notif_validation_prix" :key="index" class="mt-3"> 
                    <!-- <div class=""> -->

                  <div class="list-group-item"><p class=""><span class="new-title"> {{ $tc('message.doctorName', 1) }}</span>: <span class="font-weight-bold text-gray mr-4">{{ validation.consultation.author.nom.length > 40 ? validation.consultation.author.nom.substring(0, 40)+' ...' : validation.consultation.author.nom }}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="new-title">{{ $t('message.consultationDate')}}</span>: <span class="font-weight-bold text-gray">{{validation.consultation.date_consultation}}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="new-title">{{ $t('message.motif', 1)}}</span>: <span class="font-weight-bold text-gray mr-4">{{validation.consultation.ligne_de_temps.motif.description}}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="mr-2 new-title">{{ $t('message.patients')}}</span>: <span class="font-weight-bold text-gray">{{validation.consultation.dossier.patient.user.nom}}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="new-title">{{ $t('message.createdAt', 1)}}</span>: <span class="font-weight-bold text-gray">{{ new Date(validation.consultation.created_at).toLocaleString().split(",")[0] }}</span></p></div>
                  <div class="list-group-item justify-content-center">
                    <!-- <span class="mr-2 new-title">{{ $tc('message.operations', 1)}}</span> -->
                          <!-- <span class=""> -->
                            <div class="d-flex justify-content-center" v-if="validation.consultation != null">
                              <div v-if="validation.etat_validation_souscripteur == null">
                                  <b-link :to="{ name: 'examen-validation-prix', params: { consultation: validation.consultation.slug },query:{activeTab:'examen'} }">
                                      <button class="bg-danger text-white border-0 border-danger rounded">
                                        <i class="fas fa-exclamation-circle p-2"></i> Valider les examens
                                      </button>
                                  </b-link>
                              </div>
                            <div v-else>
                              <b-link :to="{ name: 'examen-validation-prix', params: { consultation: validation.consultation.slug },query:{activeTab:'view'} }">
                                    <button class="bg-success text-white border-0 border-success rounded">
                                          <i class="fa fa-eye p-2" aria-hidden="true" ></i>  Voir les examens 
                                    </button>
                              </b-link>
                                          <!-- <b-link  class="btn btn-primary text-white"> Voir </b-link> -->
                            </div>
                                                <!-- {{data.item}} -->
                                          
                                      </div>
                                        <!-- <router-link class="font-weight-bold text-primary"  id="disabled-wrapper"  :to="{ name: 'examen-validation-prix', params:{id: validation.id, texte:validation.consultation.author.nom} }">
                                          
                                           <div v-if="validation.etat_validation_souscripteur == null">
                                          <i class="fas fa-edit edit-icon"></i>
                                         </div>
                                         
                                        </router-link> -->
                                    <!-- </span>  -->
                                  
                              <!--  </div> 
                                 <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">Ajouter un Patient</span>: 
                                    <span class=""> 
                                        <b-link class="font-weight-bold text-primary" variant="primary" @click="GenerationFacture(cmd)">
                                            <i class="fa fa-print"></i> {{ $t('message.voirrecu') }}
                                        </b-link>
                                    </span></p>
                                </div>  -->
                            </div> 
                            <hr>
                         </div>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from  'moment';
import i18n from "@/plugins/i18n";
import _ from "lodash";
export default {
  name: "ValidationSouscripteur",
  computed: {
    ...mapGetters(["notif_validation_prix", 'hasAdminRole',
      'hasGestionnaireRole', 'hasPraticienRole', 'hasMedecinControleRole',]),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole;
    },
    statut:function (){
      if (this.notif_validation_prix)
        return this.notif_validation_prix.statut;
      return null;
    },
    examens_validations: function (){
        return this.notif_validation_prix;
    },
  },
  data(){
    return {
      mobileView: true,
      fields: [
          {
              key: 'consultation.author.nom',
              label: this.$i18n.tc('message.doctorName', 1),
          },
          {
              key: 'consultation.date_consultation',
              label: this.$i18n.t('message.consultationDate'),
              sortable: true
          },
          {
              key: 'consultation.ligne_de_temps.motif.description',
              label: this.$i18n.t('message.motif'),
          },
          {
              key: 'consultation.dossier.patient.user.nom',
              label: this.$i18n.t('message.patients'),
          },
          {
              key: 'consultation.created_at',
              label: this.$i18n.t('message.createdAt'),
              sortable: true
          },
          {
              key: 'action',
              label: this.$i18n.tc('message.operations', 1)
          }
      ],
    }
  },
  methods: {
    handleView() {
        this.mobileView = window.innerWidth <= 990;
    },

    getExamenValidationPrix() {
      let args = {
      };
      this.$store.dispatch("getExamenValidationPrix", {args});
    },
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.status === 'awesome') return 'table-success'
    },
    rowSelected(items) {
        this.$router.push({ name: 'examen-validation-prix', params: { consultation: items[0].slug } });
    },    
  },
  created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
  mounted() {
    this.getExamenValidationPrix();
  }
}
</script>

<style scoped>

</style>